module.exports = __webpack_public_path__ + "static/media/purchaseOrderIncoming.1887aaef.svg";